import { Component, OnInit } from '@angular/core';
import { Field } from '../../models/field.interface';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FieldConfig } from '../../models/field-config.interface';
import { Masks } from '@core/custom-validators/masks';
import { CustomValidators } from '@core/custom-validators/validators';


@Component({
  selector: 'app-form-nome',
  templateUrl: './form-nome.component.html',
  styleUrls: ['./form-nome.component.scss']
})
export class FormNomeComponent implements Field, OnInit {
  formNome: FormGroup;
  config: FieldConfig;
  group: FormGroup;
  mask = {
    mask: Masks.nome,
    guide: false,
    modelClean: true
  };
  firstSubmit = false;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.formNome = this.formBuilder.group({
      nome: ['']
    });

    if (this.config.required) {
      this.nome.setValidators(Validators.compose([
        Validators.required,
        Validators.minLength(3),
        CustomValidators.nome
      ]));
    } else {
      this.nome.setValidators(Validators.compose([
        Validators.minLength(3),
        CustomValidators.nome
      ]));
    }

    this.group.statusChanges.subscribe((val) => {
      if (!this.firstSubmit) {
        this.firstSubmit = true;
        this.nome.setValue(this.nome.value);
      }
    });

    this.nome.valueChanges.subscribe((val) => {
      if (this.nome.valid) {
        this.control.setValue(val);
      } else {
        this.control.setValue(undefined);
      }
    });
  }

  get nome() {
    return this.formNome.controls.nome;
  }

  get control() {
    return this.group.controls[this.config.name];
  }
}
